export const formatArrayText = (text, enableAccentuation) => {
    return text.split('\n').map((line) => line.trim()).filter((line) => line !== '').map(line => enableAccentuation ? line : normalizeString(line));
}

export function normalizeString(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function groupMultimedia(arr) {
    const result = [];
    let current = null;

    arr.forEach((item) => {
        if (!item.MULTIMEDIA) {
            result.push(item);
            return;
        }
        if (item.TEXTO && item.MULTIMEDIA) {
            if (current) result.push(current);
            current = { TEXTO: item.TEXTO, MULTIMEDIA: [item.MULTIMEDIA], MULTIMEDIA_TIPO: item.MULTIMEDIA_TIPO };
        } else if (item.MULTIMEDIA && current) {
            current.MULTIMEDIA.push(item.MULTIMEDIA);
        }
    });

    if (current) result.push(current);

    return result.map((result, index) => { return { id: index, ...result } });
}
